import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import { NOT_AUTHENTICATED_MESSAGE } from '../../authorization/requireAuthContext'
import Filter from './filter'
import EntityTypeId = com.eidu.entity.type.EntityTypeId

type GetEntityCountParameters = {
  typeId: EntityTypeId
  query?: string
  filters?: Filter[]
  signal?: AbortSignal
}

const getEntityCount = async ({ typeId, query, filters, signal }: GetEntityCountParameters): Promise<number> => {
  const params = new URLSearchParams()

  if (query) {
    params.append('query', query)
  }

  filters?.forEach((f) => params.append('filter', `${f.fieldId}:${f.value}`))

  const response = await fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/types/${typeId.toString()}/entities/count?${params.toString()}`,
    {
      headers: {
        Accept: 'application/json',
      },
      signal,
    }
  )

  switch (response.status) {
    case 200: {
      const data = await response.json()
      return data.count
    }
    // Only after fetchAuthorized has already renewed the token and retried, so the session
    // is genuinely gone rather than momentarily stale — say so instead of reporting a count of 0.
    case 401:
      throw Error(NOT_AUTHENTICATED_MESSAGE)
    case 403:
      return 0
    default:
      throw Error(`Unexpected response code ${response.status} from getEntityCount endpoint`)
  }
}

export default getEntityCount
